var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShorts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2342 5.7953H15.3668C15.5071 6.69346 15.903 7.76425 16.7114 8.69525C17.5017 9.60554 18.6528 10.3435 20.2518 10.6717L21.9801 19.2711C22.0865 19.8009 21.7561 20.3205 21.2295 20.4515L15.128 21.9694C14.543 22.115 13.9582 21.7251 13.859 21.1331C13.5252 19.1401 12.7626 15.157 12 15.157C11.2374 15.157 10.4749 19.1401 10.141 21.1331C10.0418 21.7251 9.45703 22.115 8.87195 21.9694L2.77053 20.4515C2.24386 20.3205 1.91345 19.8009 2.01992 19.2711L3.74821 10.6717C5.34719 10.3435 6.4983 9.60554 7.28864 8.69525C8.09695 7.76425 8.49286 6.69346 8.63317 5.7953H10.7658L9.2837 8.7451C9.0953 9.12006 9.24803 9.576 9.62482 9.76348C10.0016 9.95096 10.4598 9.79898 10.6482 9.42402L12 6.73355L13.3518 9.42402C13.5402 9.79898 13.9984 9.95096 14.3752 9.76348C14.752 9.576 14.9047 9.12006 14.7163 8.7451L13.2342 5.7953Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88086 4.27718V3.01208C4.88086 2.45312 5.3362 2 5.89789 2H18.1022C18.6638 2 19.1192 2.45312 19.1192 3.01208V4.27718H4.88086Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8657 7.70273C17.3354 7.09199 17.0472 6.39548 16.9175 5.7953H19.2717L19.9194 9.01784C18.9768 8.7141 18.3209 8.227 17.8657 7.70273Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08248 5.7953H4.72823L4.08057 9.01783C5.02312 8.7141 5.67907 8.22699 6.13425 7.70273C6.66451 7.09199 6.95273 6.39548 7.08248 5.7953Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShorts);
export default __webpack_public_path__ + "static/media/shorts.2e794718d72bb30935e6216c99756072.svg";
export { ForwardRef as ReactComponent };